import {
  Card, Title, Text, Badge,
  Table, TableHead, TableBody, TableRow, TableHeaderCell, TableCell,
} from '@tremor/react';
import type { PartMovementEvent, PartMovementType } from '../api/types';
import { t } from '../lib/i18n';

const mxn = (n: number | null) =>
  n === null
    ? '—'
    : n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 2 });

const badgeColor: Record<PartMovementType, 'blue' | 'green' | 'amber' | 'red'> = {
  sale: 'blue',
  receipt: 'green',
  transfer_in: 'amber',
  transfer_out: 'amber',
  return: 'red',
};

export default function PartMovementTimeline({ events }: { events: PartMovementEvent[] }) {
  return (
    <Card>
      <Title>{t.part.movement.title}</Title>
      {events.length === 0 ? (
        <Text className="mt-2">{t.part.movement.empty}</Text>
      ) : (
        <Table className="mt-2">
          <TableHead>
            <TableRow>
              <TableHeaderCell>{t.part.movement.cols.tdate}</TableHeaderCell>
              <TableHeaderCell>{t.part.movement.cols.event}</TableHeaderCell>
              <TableHeaderCell className="text-right">{t.part.movement.cols.qty}</TableHeaderCell>
              <TableHeaderCell className="text-right">{t.part.movement.cols.store}</TableHeaderCell>
              <TableHeaderCell className="text-right">{t.part.movement.cols.ref}</TableHeaderCell>
              <TableHeaderCell className="text-right">{t.part.movement.cols.unitPrice}</TableHeaderCell>
              <TableHeaderCell>{t.part.movement.cols.counterparty}</TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((e, idx) => (
              <TableRow key={`${e.tdate}-${e.event_type}-${e.sid}-${e.ref_num}-${idx}`}>
                <TableCell>{e.tdate}</TableCell>
                <TableCell>
                  <Badge color={badgeColor[e.event_type]}>
                    {t.part.movement.types[e.event_type]}
                  </Badge>
                </TableCell>
                <TableCell className={'text-right ' + (e.qty < 0 ? 'text-red-600 dark:text-red-400' : '')}>
                  {e.qty}
                </TableCell>
                <TableCell className="text-right">{e.sid}</TableCell>
                <TableCell className="text-right">{e.ref_num}</TableCell>
                <TableCell className="text-right">{mxn(e.unit_price_mxn)}</TableCell>
                <TableCell>{e.counterparty || '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Card>
  );
}
